<template>
    <section class="c-intro pst-100 psb-100 pst-md-150 psb-md-150 bg-white" ref="$intro">
        <div class="c-container">
            <div class="c-row">
                <div class="c-grid justify-center">
                    <div class="cell sm-12 md-10">
                        <div v-if="data.label" class="c-intro__subheadline psb-20">{{ data.label }}</div>
                        <div v-if="!!data.logo.length" class="c-intro__logo psb-30">
                            <UiImage :src="data.logo[0].url" :alt="data.logo[0].title" />
                        </div>
                        <div class="c-intro__headline psb-40" v-html="data.text"></div>
                        <div
                            v-if="data.description"
                            class="c-intro__description"
                            v-html="nl2br(data.description)"
                        ></div>
                    </div>
                    <div class="cell sm-12 md-12 lg-11 xl-10">
                        <div v-if="!!data.images.length" class="c-intro__gallery pst-50 pst-md-100" ref="$gallery">
                            <div v-for="item in data.images" :key="item.id" class="item">
                                <div class="image__obj image__radius bottom" ref="$images">
                                    <UiImage :src="item.webp" :alt="item.title" :classes="'responsive'" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
    const props = defineProps({
        data: {
            type: Object,
            default: {}
        }
    });

    const { $gsap: gsap, $SplitText: SplitText } = useNuxtApp();
    const $gallery = ref(null);
    const $images = ref(null);
    const $intro = ref(null);

    useStartAnimations(() => {
        const splittedEl = document.querySelector(".c-intro__headline");

        gsap.set($images.value, {
            webkitClipPath: "inset(0% 0% 100% 0%)",
            clipPath: "inset(0% 0% 100% 0%)"
        });

        if (splittedEl) {
            const splitted = new SplitText(splittedEl, { type: "words,chars" });
            gsap.set(splitted.chars, {
                filter: "grayscale(100%)",
                opacity: 0.25
            });

            gsap.timeline({
                onReverseComplete: () => {
                    gsap.to($images.value, {
                        duration: 0.8,
                        stagger: {
                            each: 0.12
                        },
                        webkitClipPath: "inset(0% 0% 100% 0%)",
                        clipPath: "inset(0% 0% 100% 0%)",
                        ease: "power2"
                    });
                },
                onComplete: () => {
                    gsap.to($images.value, {
                        duration: 0.8,
                        stagger: {
                            each: 0.12
                        },
                        webkitClipPath: "inset(0% 0% 0% 0%)",
                        clipPath: "inset(0% 0% 0% 0%)",
                        ease: "power4"
                    });
                },
                scrollTrigger: {
                    trigger: $intro.value,
                    start: "top top",
                    end: "+=50%",
                    pin: true,
                    pinSpacer: false,
                    scrub: 0.1,
                    invalidateOnRefresh: true
                }
            }).to(splitted.chars, {
                filter: "grayscale(0%)",
                opacity: 1,
                stagger: 0.1,
                ease: "none"
            });
        }
    });
</script>
